import { ActivityFn } from "single-spa";
import { pathname, rootpath } from "./helpers";

export const shouldLoadDatalayer = (location: Location) => {
  return (
    /**
     * This is blocked as it is an callback in an iFrame
     */
    !pathname(`/payment-page/callback`)(location) &&
    /**
     * When we are on the logout page so won't have access to scene
     */
    !pathname("/logout")(location) &&
    /**
     * When we are on the logged out page so won't have access to scene
     */
    !pathname("/logged-out")(location) &&
    /**
     * When we are on the cloud id page so won't have access to scene
     */
    !pathname("/cloudid/callback")(location) &&
    /**
     * When we are on the invitations page you are logged out so won't have access to scene
     */
    !pathname("/invitations")(location) &&
    /**
     * When we are on the shared invoice public page so won't have access to scene
     */
    !pathname("/accounts/invoicing/preview")(location) &&
    /**
     * When we are on the pay now public page so won't have access to scene
     */
    !pathname("/accounts/invoicing/payment")(location) &&
    /**
     * When we are on the error route and can't assume that scene is available
     */
    !pathname("/error")(location) &&
    /**
     * Calling scene here results in a 404 from orgService when attempting a redirect after login with a platform query param
     */
    !rootpath()(location)
  );
};

export const shouldShowGlobalNav = (location: Location) => {
  return (
    !pathname("/payment-page/callback")(location) &&
    !pathname("/accounts/invoicing/preview")(location) &&
    !pathname("/accounts/invoicing/payment")(location) &&
    !pathname("/desktop/copilot")(location) &&
    !pathname("/generation_experts")(location) &&
    !pathname("/cloudid/callback")(location) &&
    !pathname("/vscode/copilot")(location) &&
    !pathname("/error")(location)
  );
};

export const shouldShowSpayAdvWebApp: ActivityFn = (location) => {
  return pathname("/app")(location);
};

export const shouldShowSpayAdvRegistration: ActivityFn = (location) => {
  return pathname("/register")(location);
};

export const shouldShowSpayAdvRegistrationPending: ActivityFn = (location) => {
  return pathname("/registration-pending")(location);
};
